import { Public } from '@ikegps/core-api';
import type { ModelFieldStateVerticalSeparation } from '@ikegps/core-shared';
import { InputState } from './input.state';

export class VerticalSeparationInputState extends InputState<Public.DistanceInMeters> {
	constructor(label: string) {
		super(label);
	}

	validateInput(value: ModelFieldStateVerticalSeparation) {
		if (value) {
			if (!value.drawableTop || !value.drawableBottom) {
				this.setError('error');
				return;
			}
		}
		this.setError(null);
	}
}
